import axios from '@/js/lib/helper/axios';

export const updateToken = async (): Promise<string> => {
  const res = await axios.get('/api/csrf_token');
  return res.data.csrf_token;
};
